import { render } from "./CrmappInsights.vue?vue&type=template&id=4066e708&scoped=true"
import script from "./CrmappInsights.vue?vue&type=script&lang=js"
export * from "./CrmappInsights.vue?vue&type=script&lang=js"

import "./CrmappInsights.vue?vue&type=style&index=0&id=4066e708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4066e708"]])

export default __exports__